import { render, staticRenderFns } from "./vendorPopUp.vue?vue&type=template&id=22dd8b24&scoped=true&"
import script from "./vendorPopUp.vue?vue&type=script&lang=js&"
export * from "./vendorPopUp.vue?vue&type=script&lang=js&"
import style0 from "./vendorPopUp.vue?vue&type=style&index=0&id=22dd8b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd8b24",
  null
  
)

export default component.exports